import React from "react";

export default function Emcourse() {
  return <div></div>;
}
